import { apiBaseURL } from '../../constants';
import apiConfig from '../../config/apiConfig';

// Thin pass-through thunk (axios promise returned untouched).
export const searchRecordRaw = (config) => () => apiConfig.get(apiBaseURL.SEARCH, config)
